const USER_MANAGEMENT_ADMIN = 'ADMIN';

const APPS_MAINTENANCE_VIEW_DETAILS = JSON.parse(process.env.REACT_APP_S3_APPS_MAINTENANCE_VIEW_DETAILS) || {};

export { USER_MANAGEMENT_ADMIN, APPS_MAINTENANCE_VIEW_DETAILS };
